<template>
  <v-card>
    <v-toolbar dense card class="ocorrencia-nav">
      <v-toolbar-title class="body-2">
        <span v-show="$vuetify.breakpoint.mdAndUp">Atividade: </span>
        <router-link :to="{ name: 'altera atividade', params: { id: atividade.IdAtividade } }">{{ atividade.Atividade }}</router-link>
        ({{ atividade.Ocorrencias.length }})
      </v-toolbar-title>
      <template v-slot:extension v-if="atividade.Clientes">
        <span class="text-truncate">
          <span class="body-2" v-show="$vuetify.breakpoint.mdAndUp">Clientes: </span>
          <v-chip v-for="cliente in clientes" :key="cliente">{{ cliente }}</v-chip>
        </span>
      </template>
      <v-toolbar-items>
        <v-tooltip bottom>
          <v-btn flat icon @click="$emit('paraExecucaoOcorrencia', ocorrenciaStatusP)" v-if="mostraAcoes" slot="activator">
            <v-icon>clear</v-icon>
          </v-btn>
          <span>Parar Execução</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn flat icon @click="$emit('finalizaOcorrenciaModal', ocorrenciaStatusP)" v-if="mostraAcoes" slot="activator">
            <v-icon>check</v-icon>
          </v-btn>
          <span>Finalizar Execução</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text class="py-1 px-4" v-if="atividade.Ocorrencias.length">
      <div v-for="(ocorrencia, i) of atividade.Ocorrencias.reverse()" :key="i">
        <div class="d-flex align-center">
          <h5>{{ ocorrencia.Colaborador }}</h5>
          <div class="text-xs-right" v-if="ocorrencia.IdTipoOcorrencia === 3">
            <v-chip outline color="success">
              <v-icon left>check</v-icon>
              <span>Finalização</span>
            </v-chip>
          </div>
        </div>
        <div class="markdown-container prewrap" v-html="compileMarkdown(ocorrencia.Descricao)"></div>
        <div class="text-xs-right caption font-italic">
          {{ moment(ocorrencia.DataOcorrencia).format('lll') }} 
          ({{ moment(ocorrencia.Duracao).format('HH:mm') }})
        </div>
        <v-divider
          v-if="i !== atividade.Ocorrencias.length - 1"
          :key="i + atividade.DataOcorrencia"
          class="my-1"
        ></v-divider>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import marked from 'marked';

export default {
  name: 'CardOcorrencia',
  props: {
    atividade: {
      type: Object,
      default: () => ({
        IdAtividade: '',
        Atividade: '',
        Ocorrencias: []
      })
    },
  },
  data: () => ({
    ocorrenciaStatusP: null
  }),
  computed: {
    ...mapGetters(['user']),
    clientes() {
      return this.atividade.Clientes ? this.atividade.Clientes.split(';') : [];
    },
    mostraAcoes() {
      const userOcorrencias = this.atividade.Ocorrencias.filter(ocorrencia => ocorrencia.IdColaborador == this.user.IdColaborador);
      const ocorrenciaPendente = userOcorrencias.find(ocorrencia => ocorrencia.Status.startsWith('P'));
      this.ocorrenciaStatusP = ocorrenciaPendente;
      return ocorrenciaPendente ? true : false;
    }
  },
  methods: {
    compileMarkdown(text) {
      return marked(text);
    },
  }
}
</script>

<style scoped>
.prewrap {
  white-space: pre-wrap;
}
.ocorrencia-nav > :first-child {
  justify-content: space-between;
}
</style>